import myPreivew from "./index.vue"; // 引入组件
let visible = false;
let instance;
const getFileType = (format) => {
  let type = "";
  switch (format) {
    case "png":
    case "jpg":
    case "gif":
    case "bmp":
      type = "image";
      break;
    case "mp4":
    case "flv":
    case "wmv":
    case "3gp":
    case "avi":
      type = "video";
      break;
    case "mp3":
    case "wma":
    case "wav":
    case "amr":
    case "m4a":
    case "aac":
      type = "audio";
      break;
    default:
      type = "file";
      break;
  }
  return type;
};
const preview = {
  install(Vue, options = {}) {
    let opt = myPreivew.data(); // 获取组件中的默认配置
    Object.assign(opt, options); // 合并配置,最终返回opt以一个对象的形式
    Vue.prototype.$mediaPreview = (file) => {
      if (typeof file == "string") {
        let format = file.slice(file.lastIndexOf(".") + 1).toLowerCase();
        opt.fileType = getFileType(format);
        opt.fileUrl = file;
      } else {
        if (file.fileName) {
          let format = file.fileName
            .slice(file.fileName.lastIndexOf(".") + 1)
            .toLowerCase();
          opt.fileType = getFileType(format);
        } else {
          opt.fileType = "file";
        }
        opt.fileUrl = file.fileUrl;
      }
      if (opt.fileType != "file") {
        let previewConstructor = Vue.extend(myPreivew); // 创建一个TempToastConstructor组件
        instance = new previewConstructor({
          data: opt,
        });
        instance.vm = instance.$mount();
        //没有挂载到任何文档中，模板将被渲染为文档之外的的元素，并且你必须使用原生DOM API把它插入文档中。该方法返回实例自身。
        // console.log(instance.vm === instance)  // 输出为true
        document.body.appendChild(instance.vm.$el); //el对应的就是组件的dom元素
        instance.vm.visible = visible = true;
      }
    };
  },
};

export default preview;
